import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../assets/css/App.css';
import Background from "../assets/images/background.jpg";
import { relative } from 'upath';
import Header2 from './public';

const { SubMenu } = Menu;
const {
  Content, Footer
} = Layout;



class WelcomeChi extends React.Component{
    constructor(props){
        super(props);
        this.state={
        }
    }
    
    componentWillMount(){
   
    }

    render(){
        return(
            
            <div style={{width:"100%"}}>
            <Header2></Header2>
            <Content style={{ padding: '0 50px' }}>

                <div>
                <div style={{background: `url(${Background}) no-repeat center center`,height:300,width: "100%",backgroundSize: "cover",}}>
                <div style={{textAlign:"center"}}>
                <br></br><br></br>
                  <txt style={{fontSize:50,fontWeight:'bold'}}>CIITOOL临床辅助诊疗平台</txt> <br></br><br></br>
                  <txt style={{fontSize:45,fontWeight:'bold',}}>我们致力于通过医学影像分析技术提高人类癌症的临床治疗水平</txt>
                  </div>
                </div>



                <div style={{width:"100%"}}>

                    {/* 两个Module为一行*/}
                    
                    <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width: "50%",position:relative}}>

                        <txt style={{fontSize:28,fontWeight:'bold',textAlign:"center"}}><Link to="/mifa">医学影像特征与人类癌症关系图谱研究</Link></txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>研究概述: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        针对日益成熟的医学图像特征分析技术，本研究回顾了利用医学图像提取定量或定性癌症特异性图像特征以辅助癌症相关临床实践的研究。 本研究对先前报道的图像相关临床研究进行综述分析，总结用于解决各部位癌症临床问题的重要的医学图像特征。 我们的研究目的是为每个癌症相关问题构造与之对应的影像学特征集，以指导未来针对人类癌症的医学图像研究。 我们在PubMed中搜索了从数据库创建到2018年3月23日发表的研究，检索明确提出医学图像特征的解码方式与所解决的癌症临床问题，为这些问题从影像学角度提供新的临床辅诊方法。
                        </txt><br></br>
                        <img src={require('../assets/images/MIFA.jpg')} style={{ width: "100%",float:"center",backgroundSize: "cover"}}/>
                    </div>
                    <div style={{float:"left", paddingTop:60,paddingLeft:20,paddingRight:100,paddingBottom:60,width: "50%",position:relative}}>
                        <txt style={{fontSize:28,fontWeight:'bold',textAlign:"center"}}><Link to="/hcc-chi">肝细胞癌TACE手术预后研究</Link></txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>研究概述: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        肝细胞癌患者经TACE手术后一个月的碘油沉积状况是临床最常用的疗效评估指标。 之前的研究已经证实，其定量评估为随后的治疗决策和随访计划的制定提供了重要参考。 然而，目前国内外关于术后碘油沉积分析的分类方法并不统一，现有的评价方法多为单变量评价方法，例如沉积形态，沉积比率，沉积模式和癌区坏死等。现有多项研究指出，TACE后一个月对碘油沉积的综合客观分析对于更加精准的临床治疗决策是必不可少的。 我们的研究提出了一种定量化碘油沉积评价方法，用于在肝细胞癌患者TACE术后一个月从不同的临床分析角度对碘油沉积进行科学规范的测量分析，从而指导个体化随访诊疗。
                        </txt><br></br>
                        <img src={require('../assets/images/HCC1.jpg')} style={{ width: "100%",float:"center",backgroundSize: "cover"}}/>
                    </div><div style={{clear:"both"}}></div>
{/* 两个Module为一行
                     <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width:document.body.scrollWidth/2.2}}>

                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}>1</txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        E1</txt>
                        <br></br>
                        <img src={require('../assets/images/jds.jpg')} style={{ height:390,float:"left",backgroundSize: "cover"}}/>
                    </div>
                    <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width:document.body.scrollWidth/2.2}}>
                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}>1</txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        E1</txt>
                        <br></br>
                        <img src={require('../assets/images/jds.jpg')} style={{ height:390,float:"left",backgroundSize: "cover"}}/>
                    </div><div style={{clear:"both"}}></div> 
*/}             
                </div>
                
            </div>
            </Content>
            <Footer style={{fontSize:15}}><txt style={{fontWeight:'bold'}}>免责声明： </txt>本网站所提供的信息，只供参考之用。

本网站及其雇员一概毋须以任何方式就任何信息传递或传送的失误、不准确或错误对用户或任何其他人士负任何直接或间接的责任。

在法律允许的范围内，本网站在此声明,不承担用户或任何人士就使用或未能使用本网站所提供的信息或任何链接或项目所引致的任何直接、间接、附带、从属、特殊、惩罚性或惩戒性的损害赔偿（包括但不限于收益、预期利润的损失或失去的业务、未实现预期的节省）。

本网站所提供的信息，若在任何司法管辖地区供任何人士使用或分发给任何人士时会违反该司法管辖地区的法律或条例的规定或会导致本网站或其第三方代理人受限于该司法管辖地区内的任何监管规定时，则该等信息不宜在该司法管辖地区供该等任何人士使用或分发给该等任何人士。用户须自行保证不会受限于任何限制或禁止用户使用或分发本网站所提供信息的当地的规定。

本网站图片，文字之类版权申明，因为网站可以由注册用户自行上传图片或文字，本网站无法鉴别所上传图片或文字的知识版权，如果侵犯，请及时通知我们，本网站将在第一时间及时删除。

凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。
            <Footer style={{textAlign:"center"}}>
            <a href="http://www.beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{textAlign:"center"}}>辽ICP备19003707号</a>
            </Footer>
            </Footer>
            </div>
        )
    }
}
export default WelcomeChi;